var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashIcnDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.60547 4.60791L5.3544 16.5909C5.38998 17.2833 5.89364 17.7892 6.5527 17.7892H13.4429C14.1046 17.7892 14.5989 17.2833 14.6412 16.5909L15.3901 4.60791",
    stroke: "#585858",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.41016 4.60791H16.5914",
    stroke: "#585858",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.697 7.00412L12.3974 15.3922M7.60426 4.60753V3.10966C7.60392 2.99154 7.62693 2.87452 7.67197 2.76533C7.71701 2.65613 7.7832 2.55692 7.86672 2.4734C7.95024 2.38988 8.04945 2.32369 8.15865 2.27865C8.26784 2.23361 8.38486 2.2106 8.50298 2.21094H11.4987C11.6168 2.2106 11.7339 2.23361 11.8431 2.27865C11.9522 2.32369 12.0515 2.38988 12.135 2.4734C12.2185 2.55692 12.2847 2.65613 12.3297 2.76533C12.3748 2.87452 12.3978 2.99154 12.3974 3.10966V4.60753H7.60426ZM10.0009 7.00412V15.3922V7.00412ZM7.30469 7.00412L7.60426 15.3922L7.30469 7.00412Z",
    stroke: "#585858",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcnDisabled);
export default __webpack_public_path__ + "static/media/trash_icn_disabled.5d68acb7a6caa5bbc2b975844721d638.svg";
export { ForwardRef as ReactComponent };